import React, {useEffect, useState} from "react";
import {Layout, Button, Drawer, Typography} from "antd";
import NavMenu from "./NavMenu";
import {MenuFoldOutlined, MenuUnfoldOutlined} from "@ant-design/icons";
import {useLocation} from "react-router-dom";

const {Title} = Typography;
const NavBar = () => {
    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
        setVisible(!visible);
    };

    const {pathname: location} = useLocation();
    useEffect(() => {
        setVisible(false);
    }, [location]);

    return (
        <Layout.Header style={{backgroundColor: "#58B2DC", borderBottom: "1px solid #58B2DC", paddingLeft: 30, paddingRight:10}}>
                <div className="logo" style={{paddingRight:20}}>
                    <Title level={3} className="brand-font"
                           style={{color: "#1402f6", textShadow: "-1px -1px rgb(255 255 255 / 60%), 1px 1px"}}>
                        PhiSiCal-Checkup</Title>
                </div>
                <div className="navbar-menu">
                    <div className="navMenu">
                        <NavMenu mode={"horizontal"} defaultSection={location}/>
                    </div>
                    <Button className="menuButton" type="text" onClick={showDrawer}>
                        {(visible ? <MenuUnfoldOutlined style={{fontSize: '1.3em'}}/> :
                            <MenuFoldOutlined style={{fontSize: '1.3em'}}/>)}
                    </Button>

                    <Drawer
                        title={<h3 className="brand-font" style={{
                            padding: 10,
                            color: "#1402f6",
                            textShadow: "-1px -1px rgb(255 255 255 / 20%), 1px 1px"
                        }}><b>𝜙𝛹𝜒</b>al-Checkup</h3>}
                        placement="right"
                        closable={true}
                        onClose={showDrawer}
                        open={visible}
                        zIndex={100001}
                    ><NavMenu mode={"inline"}/>
                    </Drawer>
                </div>
        </Layout.Header>

    );
};

export default NavBar;